"use strict";

var _classCallCheck = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _get = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/get");

var _inherits = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var HTMLElementImpl = require("./HTMLElement-impl").implementation;

var idlUtils = require("../generated/utils");

var descendantsByHTMLLocalNames = require("../helpers/traversal").descendantsByHTMLLocalNames;

var domSymbolTree = require("../helpers/internal-constants").domSymbolTree;

var createHTMLCollection = require("../../living/html-collection").create;

var notImplemented = require("../../browser/not-implemented");

var reflectURLAttribute = require("../../utils").reflectURLAttribute; // http://www.whatwg.org/specs/web-apps/current-work/#category-listed


var listedElements = new Set(["button", "fieldset", "input", "keygen", "object", "select", "textarea"]);
var encTypes = new Set(["application/x-www-form-urlencoded", "multipart/form-data", "text/plain"]);
var methods = new Set(["get", "post", "dialog"]);

var HTMLFormElementImpl = /*#__PURE__*/function (_HTMLElementImpl) {
  _inherits(HTMLFormElementImpl, _HTMLElementImpl);

  function HTMLFormElementImpl() {
    _classCallCheck(this, HTMLFormElementImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(HTMLFormElementImpl).apply(this, arguments));
  }

  _createClass(HTMLFormElementImpl, [{
    key: "_descendantAdded",
    value: function _descendantAdded(parent, child) {
      var form = this;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = domSymbolTree.treeIterator(child)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var el = _step.value;

          if (typeof el._changedFormOwner === "function") {
            el._changedFormOwner(form);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      _get(_getPrototypeOf(HTMLFormElementImpl.prototype), "_descendantAdded", this).apply(this, arguments);
    }
  }, {
    key: "_descendantRemoved",
    value: function _descendantRemoved(parent, child) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = domSymbolTree.treeIterator(child)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var el = _step2.value;

          if (typeof el._changedFormOwner === "function") {
            el._changedFormOwner(null);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      _get(_getPrototypeOf(HTMLFormElementImpl.prototype), "_descendantRemoved", this).apply(this, arguments);
    }
  }, {
    key: "_dispatchSubmitEvent",
    value: function _dispatchSubmitEvent() {
      var ev = this._ownerDocument.createEvent("HTMLEvents");

      ev.initEvent("submit", true, true);

      if (this.dispatchEvent(ev)) {
        this.submit();
      }
    }
  }, {
    key: "submit",
    value: function submit() {
      notImplemented("HTMLFormElement.prototype.submit", this._ownerDocument._defaultView);
    }
  }, {
    key: "reset",
    value: function reset() {
      Array.prototype.forEach.call(this.elements, function (el) {
        el = idlUtils.implForWrapper(el);

        if (typeof el._formReset === "function") {
          el._formReset();
        }
      });
    }
  }, {
    key: "elements",
    get: function get() {
      var _this = this;

      return createHTMLCollection(this, function () {
        return descendantsByHTMLLocalNames(_this, listedElements);
      });
    }
  }, {
    key: "length",
    get: function get() {
      return this.elements.length;
    }
  }, {
    key: "method",
    get: function get() {
      var method = this.getAttribute("method");

      if (method) {
        method = method.toLowerCase();
      }

      if (methods.has(method)) {
        return method;
      }

      return "get";
    },
    set: function set(V) {
      this.setAttribute("method", V);
    }
  }, {
    key: "enctype",
    get: function get() {
      var type = this.getAttribute("enctype");

      if (type) {
        type = type.toLowerCase();
      }

      if (encTypes.has(type)) {
        return type;
      }

      return "application/x-www-form-urlencoded";
    },
    set: function set(V) {
      this.setAttribute("enctype", V);
    }
  }, {
    key: "action",
    get: function get() {
      var attributeValue = this.getAttribute("action");

      if (attributeValue === null || attributeValue === "") {
        return this._ownerDocument.URL;
      }

      return reflectURLAttribute(this, "action");
    },
    set: function set(V) {
      this.setAttribute("action", V);
    }
  }]);

  return HTMLFormElementImpl;
}(HTMLElementImpl);

module.exports = {
  implementation: HTMLFormElementImpl
};